module.exports = __webpack_public_path__ + "static/media/ybor-slide-06.8d6bba1d.png";